import settings from '../config/settings';
import axios from './axios';

const { apiBaseURL } = settings;

export default class InstitutionApi {
  static updateInstitution(data) {
    return axios.patch(`${apiBaseURL}/institutions/${data.currentInstitutionId}`, data);
  }
}



// WEBPACK FOOTER //
// ./src/api/InstitutionApi.js